import type { LayerPopupConfiguration } from './model';

export function createDefaultLayerPopupConfiguration(): LayerPopupConfiguration {
  return {
    enabled: false,
    titleField: null,
    fields: [],
  };
}
